import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Table } from '../../models/order-tracker/table.model';
import { DeserializationUtils } from '../../utils/deserialization-utils';

@Injectable({ providedIn: 'root' })
export class CheckInService {
  private readonly BASE_PATH = '/ws/integrated/v1';

  constructor(private httpClient: HttpClient) {}

  public fetchTables(): Observable<Table[]> {
    return this.httpClient
      .get(`${this.BASE_PATH}/tables`)
      .pipe(map((json: Object[]) => DeserializationUtils.deserializeArray(json, Table)));
  }

  public checkIn(table: string, orderId: string): Observable<any> {
    const params = new HttpParams().set('table', table).set('orderId', orderId);
    return this.httpClient.post(`${this.BASE_PATH}/ordering/order/checkIn`, null, { params });
  }
}
